<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >

      <el-table-column
        prop="store_image"
        label="Store Image"
        width="120"
      >
        <template slot-scope="scope">
          <img :src="scope.row.store_image" width="100" :height="scope.row.store_image_is_profile_image ? 100 : 30"/>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="store_name"
        label="Store Name"
        width="150"
      />

      <el-table-column
        :label="$t('table.title')"
        prop="title"
        min-width="120"
      />

      <el-table-column
        label="Description"
        prop="description"
        min-width="250"
      />

      <el-table-column
        label="Code"
        prop="code"
        min-width="80"
      />

      <!-- <el-table-column
        label="Discount Percentage"
        prop="discount_percentage"
        min-width="80"
      /> -->

      <el-table-column
        label="Evergreen"
        prop="is_evergreen_text"
        min-width="60"
      />

      <el-table-column
        label="Sort"
        prop="sort"
        min-width="60"
      />

      <el-table-column
        label="Featured Sort"
        prop="featured_sort"
        min-width="60"
      />

      <el-table-column
        label="End At"
        prop="end_at_local"
        min-width="160"
      />

      <el-table-column
        :label="$t('table.action')"
        fixed="right"
        align="center"
        width="100"
      >
        <template #default="{ row }">
          <div class="button-group">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleEditButtonClick(row)"
            />
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="handleDeleteButtonClick(row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import CouponService from '../../api/coupon'
import { formatDatetime } from '../../utils/datetime'

export default {
  name: 'CouponList',
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      deletingId: null,
      list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleCreate() {
      this.$router.push({ path: '/coupon/create' })
    },
    handleEditButtonClick(row) {
      this.$router.push({ path: `/coupon/edit/${row.id}` })
    },
    handleDeleteButtonClick(row) {
      this.$confirm(`Confirm Delete?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.deleteCoupon(row.id)
      }).catch(() => {
      })
    },
    async getList() {
      this.isLoading = true
      try {
        const response = await CouponService.getList(this.listQuery.page, this.listQuery.size)
        const { data: newList, pagination } = response
        for (const coupon of newList) {
          if (coupon.is_evergreen === 1) {
            coupon.is_evergreen_text = 'Yes'
          } else {
            coupon.is_evergreen_text = 'No'
          }

          coupon.end_at_local = coupon.end_at ? formatDatetime({date: coupon.end_at}) : ''
        }
        this.list = [...newList]
        this.listQuery.total = parseInt(pagination.total_items, 0)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async deleteCoupon(couponId) {
      this.isLoading = true
      this.deletingId = couponId
      try {
        const form = {
          is_deleted: 1,
        }
        const response = await CouponService.update(this.deletingId, form)
        if (response.code === 200) {
          const deletedIndex = this.list.findIndex(({ id }) => id === couponId)
          this.list.splice(deletedIndex, 1)
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false
        this.deletingId = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.cell {
  overflow: visible;
}

</style>
